import React, { FC } from "react";
import { Box, BoxProps } from "theme-ui";
import { Variants } from "../..";

type ButtonPrimarySecondaryProps = {
  primaryButtonText: string;
  primaryButtonLink: string;
  secondaryButtonText: string;
  secondaryButtonLink: string;
  tertiaryButtonText?: string;
  tertiaryButtonLink?: string;
} & BoxProps;

export const ButtonGroup: FC<ButtonPrimarySecondaryProps> = ({
  primaryButtonText,
  primaryButtonLink,
  secondaryButtonText,
  secondaryButtonLink,
  tertiaryButtonText,
  tertiaryButtonLink,
  children,
  ...props
}: ButtonPrimarySecondaryProps) => {
  const hasButtons =
    primaryButtonText || secondaryButtonText || tertiaryButtonText;

  const buttonsValues = [
    primaryButtonText,
    secondaryButtonText,
    tertiaryButtonText,
  ];
  const presentButtonCount = buttonsValues.filter(Boolean).length;
  const buttonsExceeded = presentButtonCount >= 3;

  if (hasButtons) {
    return (
      <Box {...props} sx={{ display: "block" }}>
        <Box variant="buttonGroups">
          {primaryButtonText && (
            <Variants.LinkButton href={primaryButtonLink}>
              {primaryButtonText}
            </Variants.LinkButton>
          )}
          {secondaryButtonText && (
            <Variants.LinkButtonSecondary href={secondaryButtonLink}>
              {secondaryButtonText}
            </Variants.LinkButtonSecondary>
          )}
          {/* only max two buttons should be present at a time */}
          {tertiaryButtonText && !buttonsExceeded && (
            <Variants.LinkButtonIcon href={tertiaryButtonLink}>
              {tertiaryButtonText}
            </Variants.LinkButtonIcon>
          )}
          {children}
        </Box>
      </Box>
    );
  }
  return null;
};

ButtonGroup.defaultProps = {
  tertiaryButtonText: "",
  tertiaryButtonLink: "",
};
